// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from './UserInfoCell'
import { User } from '../../core/_models'
import CustomHeader from '../../../../components/header/CustomHeader'
import { CreatedAtCell } from '../../../../users/table/columns/CreatedAtCell'
import { navigateToStore } from '../../../../core/helper'

// const { auth } = useAuth();
const returnColumns = (navigate: any, filterQueryStr: string) => {
  const columns: ReadonlyArray<Column<User>> = [
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Payment ID' className='min-w-110px' />
      ),
      id: 'PaymentID',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={
            <button
              className='p-0 border-0 bg-white text-primary fw-bold'
              onClick={() => {
                const id = props.data[props.row.index]?.id ?? ''
                sessionStorage.setItem('filterQueryStr', filterQueryStr)
                navigate(`/payments/transactions/${id}/details`)
              }}
            >
              {props.data[props.row.index]?.id ?? 'N/A'}
            </button>
          }
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Created at' className='mw-125px' />
      ),
      id: 'createdDateTime',
      Cell: ({ ...props }) => (
        <CreatedAtCell createdAt={props.data[props.row.index]?.createdDateTime} />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Store number' className='mw-110px' />
      ),
      id: 'storeNumber',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={
            props.data[props.row.index]?.storeRetailerRef ?? 'N/A' !== 'N/A' ? (
              <button
                className='p-0 border-0 bg-white text-primary fw-bold'
                onClick={() => {
                  navigateToStore(props.data[props.row.index]?.storeId, filterQueryStr, navigate)
                }}
              >
                {props.data[props.row.index]?.storeRetailerRef ?? 'N/A'}
              </button>
            ) : (
              props.data[props.row.index]?.storeRetailerRef ?? 'N/A'
            )
          }
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Device Name' className='mw-110px' />
      ),
      id: 'deviceName',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.deviceName ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Scheme Name' className='mw-125px' />
      ),
      id: 'paymentSchemeName',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.paymentScheme?.name ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Token ID' className='mw-125px' />
      ),
      id: 'paymentTokenId',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.paymentToken?.id ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Transaction type' className='mw-125px' />
      ),
      id: 'TransactionType',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.transactionType ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Transaction result' className='mw-125px' />
      ),
      id: 'transactionResult',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.transactionResult ?? 'N/A'}
        />
      ),
    },

    {
      Header: (props) => <CustomHeader tableProps={props} title='Amount' className='mw-100px' />,
      id: 'totalAmount',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={`${props.data[props.row.index]?.amount}` ?? 'N/A'}
        />
      ),
    },
  ]
  return columns
}

export { returnColumns }
